jQuery(function($) {

   var header_height = $('#masthead').height();

    //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();


  /* INPUT SEARCH FILTER */

  $( "form.FormSearchPlace" ).submit(function() {
       var search = $('#search-field').val().toString();
       search = search.toLowerCase();
       $( ".Date-Item-Place--city:contains("+search+")").parent().parent().slideDown(300);
       $( ".Date-Item-Place--city:not(:contains("+search+"))").parent().parent().slideUp(300);
       $( ".Date-Item--nocount").slideUp(300);
      $( ".Date-Filter-List li").removeClass('active');


       var nb_item = $(".Date-Item").not( ".Date-Item--nocount").length-1; // - 1 car déjà un pour indiquer no_result
       var nb_pas_trouve =  $( ".Date-Item-Place--city:not(:contains("+search+"))").length;

       console.log('TOTAL ITEM '+nb_item);
       console.log('TOTAL ITEM PAS TROUVE' +nb_pas_trouve);
       if(nb_item == nb_pas_trouve){
          $("#no_result").slideDown(300);
       }else{
          $("#no_result").slideUp(300);
       }
     //  console.log(nb_pas_trouve);
     if($(window).width() < 600){
      $('html, body').stop().animate({ 
            scrollTop: $('.Date-Container').offset().top-header_height-90
        }, 500);
      }

      return false;
  });

   

  /* DATE FILTER */
    $( ".Date-Filter-List button" ).click(function() {
      $('#search-field').val(''); // On remet à vide le champ de recherche 
      var filter = $(this).attr('data-filter');
      $( ".Date-Filter-List li").removeClass('active');
      $(this).parent().addClass('active');

      if(filter != '*'){
          $( ".Date-Item " ).filter( "."+filter).slideDown(300);
          $( ".Date-Item " ).not( "."+filter).slideUp(300);
      }else{
        $( ".Date-Item").not( ".Date-Item--no-result").slideDown(300);
      }

      if($(window).width() < 600){
        $('html, body').stop().animate({ 
              scrollTop: $('.Date-Container').offset().top-header_height-20
          }, 500);
      }

     
  });

  /* END DATE FILTER */

    $('a.gallery').featherlightGallery({
      galleryFadeIn: 100,          /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300          /* fadeOut speed before slide is loaded */
    });


    $(".LinkToChild-js").click(function() {
      document.location = $(this).find("a").attr("href");
    });

	

     // TABS ///
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".js-Tabs-Inner-Content").hide();
    $(".js-Tabs-Inner-Content:first").show();

  /* if in tab mode */
    $(".Tabs-Liste li").click(function() {
    
      $(".js-Tabs-Inner-Content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();    
    
      $(".Tabs-Liste li").removeClass("active");
      $(this).addClass("active");

    $(".js-Tabs-Inner-Title").removeClass("d_active");
    $(".js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");
    
    });
  /* if in drawer mode */
  $(".js-Tabs-Inner-Title").click(function() {
      
      if($(this).next().css('display') == 'none'){
          $(".js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(".js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(".Tabs-Liste li").removeClass("active");
        $(".Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");
    }else{
      $(this).next().slideUp(400);
      $(".js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");
    }
    });

  
  /* Extra class "tab_last" 
     to add border to right side
     of last tab */
  $('.Tabs-Liste li').last().addClass("tab_last");
  $('.Tabs-Liste li').first().addClass("active");

  // GET HASH ? 
   // SI #tab1, #tab2, #tab3.. alors on clique sur le li pour activer le bon js-Tabs-Inner-Content //
   if(window.location.hash) {
    var $hash_location = window.location.hash;
    if($hash_location == '#tab1' || $hash_location == '#tab2' || $hash_location == '#tab3' || $hash_location == '#tab4')
    {
      $hash_location = $hash_location.substring(1);
      $( ".Tabs-Liste li[rel='"+$hash_location+"']").trigger( "click" );
    }
  } 
  // FIN TABS 
    






  // FORM CONTACT LABEL ///
   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).click(function() {
      $( this ).parent().parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email']").focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text']" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



   

   $( ".disable_link a" ).click(function(e) {
     e.preventDefault();
  });

 });